import React from "react";
import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 30, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children }) => (
  <div className="inline-flex items-center gap-2 text-sm font-bold text-maroon-800">
    {children}
  </div>
);

export const SectionHeader = ({ overline, title, subtitle, align = "left" }) => (
  <div className={align === "center" ? "text-center mx-auto max-w-3xl" : "max-w-3xl"}>
    {overline && <Overline>{overline}</Overline>}
    <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold text-zinc-900 tracking-tight text-balance">
      {title}
    </h2>
    {subtitle && <p className="mt-4 text-zinc-600 text-base sm:text-lg leading-relaxed">{subtitle}</p>}
  </div>
);
